exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".point-readonly[data-v-3ac8941c] .theme--light.v-label{color:rgba(0,0,0,.38)!important}", ""]);
